import { UserList } from '../../../components/User';
import { UserType } from '../../../types';

export function Users() {
  return <UserList type={UserType.Member} hasLastVerified />;
}
